'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { getENV } from '../../utils/env';
export const AfterPayLegacy = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script data-testid="square-script" src={getENV("NEXT_PUBLIC_AFTERPAY_SCRIPT_URL")} async={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};